import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Form,
  Modal,
  OverlayTrigger,
  Table,
  Tooltip,
} from "react-bootstrap";
import {
  GetUserRegionsRequestData,
  InsertUserRegionsApprovalData,
} from "../../../api/Admin/serviceApi";
import Fontstyling, { tablestyle } from "../../../components/common/comman";
import "react-toastify/dist/ReactToastify.css";
import theme from "../../../Utils/theme";
import NoDataMassage from "../../../components/common/NoDataMassage";
import Loader from "../../../components/common/Loader";
import { useSelector } from "react-redux";
import toastFile from "../../../Service/ToastFile";
import {
  ApproveClinicalFormFillupRequest,
  CompleteOrCancelSBARRequest,
  GetClinicalFormFillupRequestList,
  GetSBARRequestListWithPagination,
} from "../../../api/ClinicalIntake";
import CustomMaterialTable from "../../../components/common/CustomMaterialTable";
import { useRef } from "react";
import editIcon from "../../../assets/icon/pencil-fill.svg";
import editIconWhite from "../../../assets/icon/pencil-fill-white.svg";
//import MaterialTable from "material-table";
import MaterialTable from "@material-table/core";
import { BsClipboardCheck, BsFillClipboardCheckFill } from "react-icons/bs";

const SBARIntakeRequest = ({ navigate }) => {
  const pageSize = 10;
  const column = [
    { title: "User Name", field: "userName" },
    {
      title: "Clinician Name",
      field: "doctorName",
      render: (data) => (data.doctorName ? data.doctorName : "Admin"),
    },
    { title: "Client Name", field: "clientName" },
    { title: "Plan Insights Member ID", field: "cgT_Member_ID" },
    { title: "Comment", field: "userComment" },
    {
      title: "Status",
      field: "statusName",
      render: (item) => {
        let badgeColor;
        switch (item.statusName) {
          case "Approved":
            badgeColor = "primary";
            break;
          case "Cancelled":
            badgeColor = "danger";
            break;
          case "Pending":
            badgeColor = "warning";
            break;
        }
        return (
          <Badge
            pill
            className="fw-normal py-1 px-3"
            bg={badgeColor}
            style={{ fontSize: "10px" }}
          >
            {item.statusName === "Cancelled" ? "Rejected" : item?.statusName}
          </Badge>
        );
      },
    },
    {
      title: "Actions",
      minWidth: "74px",
      maxWidth: "75px",
      cellStyle: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
      sorting: false,
      render: (rowData) => (
        <div className="d-flex align-items-center justify-content-evenly">
          {rowData.statusName !== "Accepted" && (
            <div
              className="border rounded-5"
              onClick={() => {
                setWitchAction("update");
                setSelectedRowData(rowData);
                setShowModal(true);
                setApproveStatus(
                  rowData?.statusName === "Cancelled"
                    ? 2
                    : rowData?.statusName === "Accepted"
                    ? 1
                    : 0
                );
              }}
            >
              <img
                src={
                  selectedRow === rowData.tableData.id
                    ? editIconWhite
                    : editIcon
                }
                width="11"
                className="p-0 m-2"
                alt="edit icon"
              />
            </div>
          )}
          {rowData.statusName === "Accepted" && (
            <OverlayTrigger
              placement={"left"}
              trigger={["hover", "focus"]}
              overlay={
                <Tooltip show={isTooltip}>Click to fill SBAR Form</Tooltip>
              }
            >
              <div
                className="border rounded-5"
                onClick={() => {
                  setSelectedRowData(rowData);
                  navigate("/clinicalIntake/SBAR", { state: { rowData } });
                }}
                onMouseEnter={() => setIsTooltip(true)}
                onMouseLeave={() => setIsTooltip(false)}
              >
                <BsClipboardCheck size={12} className="m-2" />
              </div>
            </OverlayTrigger>
          )}
        </div>
      ),
    },
  ];
  const filterValues = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Pending",
      value: 0,
    },
    {
      label: "Approved",
      value: 1,
    },
    {
      label: "Rejected",
      value: 2,
    },
  ];
  const user = useSelector((state) => state.userDetails.value);
  const [filterdData, setFilteredData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isChange, setIsChange] = useState(true);
  const [isTooltip, setIsTooltip] = useState(false);
  const selectedFilter = useRef("");
  const tableRef = useRef();
  const [witchAction, setWitchAction] = useState("");
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [approveStatus, setApproveStatus] = useState(0);

  useEffect(() => {
    if (isSubmit) {
      setIsSubmit(false);
      setIsChange(true);
    }
  }, [isSubmit]);

  useEffect(() => {
    tableRef.current.onQueryChange();
  }, [filterdData]);

  const fetchData = async (page) => {
    try {
      const userId = user?.UserRole === "Admin" ? 0 : user?.UD_id;
      const result = await GetSBARRequestListWithPagination(
        userId,
        page,
        pageSize,
        filterdData
      );
      if (result?.status === 200) {
        const sbarRequests = result.data.sbarRequests;
        setIsLoading(false);
        return {
          data: sbarRequests,
          page: page - 1,
          totalCount: result.data.totalPages * pageSize,
        };
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  const handelFilter = (e) => {
    let { value } = e.target;
    setFilteredData(value);
  };

  const approveRequest = () => {
    CompleteOrCancelSBARRequest(
      selectedRowData.id,
      user.UD_id,
      approveStatus
    ).then((res) => {
      if (res?.status === 200) {
        // console.log(res.data);
        setIsSubmit(true);
        tableRef.current.onQueryChange();
        toastFile(res.data, "success");
      } else {
        toastFile(res?.response?.data, "error");
      }
    });
    setShowModal(false);
  };

  return (
    <>
      {showModal && (
        <Modal
          show={showModal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton onHide={() => setShowModal(false)}>
            <Modal.Title
              id="contained-modal-title-vcenter"
              style={Fontstyling.modalHeading}
            >
              Approve SBAR Request
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="text-start">
              <Form.Label style={Fontstyling.label}>User Name:</Form.Label>
              <Form.Control
                className="py-1 rounded-0"
                style={Fontstyling.label}
                value={selectedRowData?.userName}
                type="text"
                placeholder="User name"
                disabled
              />
            </Form.Group>
            {/* <p>User Name: {selectedRowData?.UserName}</p> */}
            <Form.Group className="mb-3 mt-2" controlId="formBasicEmail">
              <Form.Label style={Fontstyling.label}>Comment:</Form.Label>
              <Form.Control
                disabled
                as="textarea"
                value={selectedRowData?.userComment}
                style={{ ...Fontstyling.label, height: "100px" }}
              />
            </Form.Group>
            <div className="d-flex align-items-center gap-5">
              <Form.Check
                type="radio"
                name="radio"
                style={Fontstyling.label}
                value={1}
                checked={approveStatus === 1}
                label="Accept"
                onChange={(e) => setApproveStatus(1)}
              />
              <Form.Check
                type="radio"
                name="radio"
                value={2}
                style={Fontstyling.label}
                checked={approveStatus === 2}
                label="Reject"
                onChange={(e) => setApproveStatus(2)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              style={Fontstyling.cancelbutton}
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              type="button"
              disabled={approveStatus === 0}
              style={Fontstyling.savebutton}
              onClick={() => approveRequest()}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <div className="d-flex align-items-center justify-content-between pb-2">
        <h5 className="mb-3 mt-1" style={{ ...Fontstyling.heading }}>
          List of SBAR Intake request
        </h5>
        <div className="d-flex align-items-center">
          <select
            className="form-select rounded-0 py-1 text-nowrap"
            style={Fontstyling.label}
            name="status"
            onChange={handelFilter}
          >
            {filterValues.map((item, index) => (
              <option
                key={index}
                value={item.value}
                selected={item.value === selectedFilter.current}
              >
                {item.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <MaterialTable
        tableRef={tableRef}
        columns={column}
        data={(query) =>
          new Promise((resolve, reject) => {
            fetchData(query?.page + 1)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          })
        }
        isLoading={isLoading}
        onRowClick={(event, rowData) => {
          if (rowData.tableData.id === selectedRow) setSelectedRow(null);
          else setSelectedRow(rowData.tableData.id);
        }}
        options={{
          sorting: false,
          draggable: false,
          actionsColumnIndex: -1,
          paging: true,
          pageSize: 10,
          pageSizeOptions: true,
          paginationType: "normal",
          search: false,
          filtering: false,
          showTitle: false,
          toolbar: true,
          toolbarButtonAlignment: "left",
          rowStyle: (rowData) => {
            const index = rowData.tableData.id;

            if (index === selectedRow) {
              return {
                padding: "0px",
                fontSize: "11px",
                fontFamily: "Arial",
                border: "1px solid #dee2e6",
                textAlign: "start",
                color: "white",
                backgroundColor: "#999999",
              };
            }
            return {
              padding: "0px",
              fontSize: "11px",
              fontFamily: "Arial",
              border: "1px solid #dee2e6",
              textAlign: "start",
            };
          },
          cellStyle: {
            textAlign: "left",
          },
          headerStyle: {
            padding: "0px",
            zIndex: 0,
            backgroundColor: "#18252D",
            color: "#EEF0E2",
            textTransform: "capitalize",
            fontSize: "11px",
            fontFamily: "Arial",
            fontWeight: "700",
            border: "1px solid #dee2e6",
            borderRight: "1px solid #dee2e6",
            borderLeft: "1px solid #dee2e6",
          },
          actionsCellStyle: {
            padding: "0px",
            maxWidth: "20px",
          },
        }}
      />
    </>
  );
};

export default SBARIntakeRequest;
